<template>
  <div :class="`business${isMobile ? ' area-mobile' : ''}`" :style="!isMobile || 'height:auto;'">
    <div class="title">
      <h1 class="tit">{{ title }}</h1>
      <h4 class="subtitle">{{ suntitle }}</h4>
    </div>
    <div class="content">
      <div class="item" v-for="(item, index) in items" :key="index" :style="!isMobile || 'width:100%;'">
        <img class="icon" :src="item.icon" alt="icon" />
        <h3 class="name">{{ item.name }}</h3>
        <span class="discription" v-html="item.discription" />
        <a class="link" href="javascript:;">详情了解 ></a>
      </div>
    </div>
  </div>
</template>

<script>
import { _isMobile } from '@/utils/config';

export default {
  name: 'business',
  // 与父组件通信
  props: {},
  // 组件
  components: {},
  // 数据
  data() {
    return {
      isMobile: _isMobile(),
      title: '一站式服务',
      suntitle: '0门槛接入，极速落地',
      items: [
        {
          icon: require('./resources/icon_note.png'),
          name: '专业技术服务',
          discription: '项目经理一对一程跟进服务；<br>强大的专业技术开大团队，可为客户提供定制化新产品开发服务',
          url: '#',
        },
        {
          icon: require('./resources/icon_core.png'),
          name: '极速联网模组',
          discription: '涵盖WiFi、BLE、2.4G协议；<br>方案覆盖照明、门锁、小家电等上千款产品',
          url: '#',
        },
        {
          icon: require('./resources/icon_shell.png'),
          name: '米家产品H5开发',
          discription: '免费公版H5极速接入<br>品牌H5品质定制开发<br>照明电工、小家电、门锁等成功案例',
          url: '#',
        },
        {
          icon: require('./resources/icon_link.png'),
          name: '强大的供应链支持',
          discription: '数十家驱动电源及电控板使用乐式方案，品牌商可快速适配核心配件',
          url: '#',
        },
      ],
    };
  },
  // 监听
  watch: {},
  // 挂载结束状态
  mounted() {},
  // 方法
  methods: {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
@import './index.less';
</style>

